import { Anchor, Building2, Droplets, Factory, Globe2, HardHat, Package, Ship, Truck, Users, Waves } from "lucide-react";

export const assets = {
  logo: "https://customer-assets-agu9un31.emergentagent.net/job_d3243424-d356-4f42-8e91-7777a60c0e05/artifacts/ltrm1mjz_image.png",
  video: "https://customer-assets-agu9un31.emergentagent.net/job_d3243424-d356-4f42-8e91-7777a60c0e05/artifacts/enbav10t_ship-cargo.mp4",
  fallback: "https://images.unsplash.com/photo-1578575437130-527eed3abbec?auto=format&fit=crop&w=2000&q=90",
  port: "https://images.unsplash.com/photo-1606185540834-d6e7483ee1a4?auto=format&fit=crop&w=1200&q=85",
};

export const services = [
  ["Shipping", "Coastal cargo distribution engineered around dependable schedules.", Ship, "wide"],
  ["Freight Charter", "Flexible voyage and contract charter solutions.", Anchor],
  ["EMKL", "Coordinated forwarding and documentation.", Package],
  ["PBM", "Experienced port handling and stevedoring.", Building2],
  ["Project Logistics", "Purpose-built moves for complex cargo.", Globe2],
  ["Ship Agency", "Reliable support at every port call.", Waves],
  ["Trucking", "Connected first and final-mile delivery.", Truck],
];

export const industries = [
  ["Mining", HardHat], ["Construction", Building2], ["Manufacturing", Factory],
  ["Oil & Gas", Droplets], ["Fertilizer", Package], ["Infrastructure", Building2], ["Government", Users],
];

export const reasons = [
  ["Nationwide Coverage", "A connected network across Indonesia's major ports."],
  ["Experienced Team", "Professional support from planning to delivery."],
  ["Safe Operations", "Safety-first processes for people, cargo, and schedules."],
  ["Competitive Freight Rates", "Commercially sound options for every shipment."],
  ["End-to-End Logistics", "One integrated team from origin to final destination."],
  ["Cargo Monitoring", "Clear operational visibility across your logistics chain."],
];

export const vessels = [
  { id: "5477758", name: "KM Citra Nusantara" },
  { id: "705394", name: "KM Heng Heng" },
  { id: "705413", name: "KM Silvy Utami" },
  { id: "703971", name: "KM Sinar Papua 88" },
];